import { useQuery } from '@tanstack/react-query';

import BackendService from '../services/backendService';
import { LessonAttachment } from '../services/backendService/backendService';

export const useAttachmentContent = (
  attachment: LessonAttachment,
  isFromDiscover: boolean,
) => {
  const { data } = useQuery(
    ['attachment', attachment.attachmentId, attachment.modifiedAt],
    async () => {
      return BackendService.instance.gameFiles.fetchAttachmentContent({
        fileId: attachment.fileId,
        isFromDiscover: isFromDiscover,
      });
    },
    {
      staleTime: 1000 * 60 * 60 * 24,
    },
  );

  return { content: data };
};
